import styled from 'styled-components';
import React from 'react';
import { Button } from '@alefeducation/ui-elements-library-core';

interface FooterProps {
  onCancel(): void;

  onAddMember?(): void;

  onEditMember?(): void;

  disableSubmitButton?: boolean;
  isEdit?: boolean;
  isOrgMember?: boolean;
  hideEditButton?: boolean;
}

export const StyledFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  column-gap: 16px;

  border-top: 1px solid ${({ theme }: any) => theme.colors.primary[10]};
  padding: ${({ theme }: any) => `${theme.space[14]}px ${theme.space[16]}px`};
`;

const Footer: React.FC<FooterProps> = ({
  isEdit = false,
  onCancel,
  onAddMember,
  disableSubmitButton = false,
  onEditMember,
  hideEditButton = false,
}) => (
  <StyledFooter>
    <Button
      variant="secondary"
      onClick={onCancel}
      data-testid={'add-edit-member-cancel-button'}
    >
      Cancel
    </Button>
    {isEdit ? (
      !hideEditButton && (
        <Button
          data-testid={'edit-member-update-button'}
          disabled={disableSubmitButton}
          onClick={onEditMember}
        >
          Save Changes
        </Button>
      )
    ) : (
      <Button
        data-testid={'add-member-add-button'}
        disabled={disableSubmitButton}
        onClick={onAddMember}
      >
        Add Member
      </Button>
    )}
  </StyledFooter>
);

export default Footer;
